export const UPLOAD_CARE_TOKEN = '1f1e6f53bd2d79c4ed86'
